/**
 * Function for delaying the js process
 * for a set time.
 */
const delay = (milliseconds: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(() => resolve(), milliseconds);
  });

export default delay;
